import React, { Component } from "react";
import { connect } from 'react-redux';
import { Row, ControlLabel } from "react-bootstrap";
import { authOperations, authSelectors } from './state';
import { Redirect, withRouter } from "react-router-dom";
import { MAIN } from '../../../routes/constants';
import { AZ_az_09, EMPTY_STRING, EMPTY_COUNT } from '../../../utils/constants'
import '../../../includes/custom/css/login.css';
import check from "../../../includes/img/check.svg";
import ErrorAlert from '../../components/ErrorAlert';
import {
  ERROR_INVALID_USERNAME_PAS,
  ERROR_PASS_CHANGE
} from "../../../utils/messages";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      cPassword: "",
      nPassword: "",
      nPassword2: "",
      success: false,
      error: []
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  isEmpty = (string) => {
    return EMPTY_STRING === string;
  }

  handleChange = (event) => {
    if (event.target.value.match(AZ_az_09) || this.isEmpty(event.target.value)) {
      this.setState({
        [event.target.name]: event.target.value
      });
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();

    this.setState({ error: [] });
    let error = authSelectors.validate(this.state)

    if (EMPTY_COUNT === error.length) {
        this.changePassword();
    } else {
      this.setState({ error: error })
    }
  }

  changePassword = () => {
    this.props.loginUser(this.state.username, this.state.cPassword, true)
      .then(result => {
        this.props.changePassword(this.state.username, this.state.nPassword, result.data.access_token)
          .then(() => {
            this.setState({ success: true })
          })
          .catch(() => {
            this.setState({ error: [ERROR_PASS_CHANGE] });
          })
      })
      .catch((e) => {
        JSON.parse(JSON.stringify(e)).response ?
           this.setState({ error: [ERROR_INVALID_USERNAME_PAS] }):
           this.setState({ error: ["NETWORK_ERR"] });
      });
  }

  inputText = (name) => {
    let type = name === "username" ? "text" : "password";
    return (
      <input name={name}
        type={type}
        onChange={this.handleChange}
        value={this.state[name]}
        minLength={8}
        maxLength={16} />
    )
  }

  form = () => {
    return (
      <div>
        <form onSubmit={this.handleSubmit}>
        <div className="changePassword">
          {this.state.error && <ErrorAlert errors={this.state.error}/>}          
          <Row>
            <span><ControlLabel className="required-input">ログインID:</ControlLabel></span>
            <span>{this.inputText("username")}</span>
          </Row>
          <Row>
            <span><ControlLabel className="required-input">現在のパスワード:</ControlLabel></span>
            <span>{this.inputText("cPassword")}</span>
          </Row>
          <Row>
            <span><ControlLabel className="required-input">新しいパスワード:</ControlLabel></span>
            <span>{this.inputText("nPassword")}</span>
          </Row>
          <Row>
            <span><ControlLabel className="required-input">新しいパスワード（確認）:</ControlLabel></span>
            <span>{this.inputText("nPassword2")}</span>
          </Row>
        </div>
        <center>
          <button className="loginButton" type="submit"
            onClick={this.handleSubmit}
          >
            パスワード変更
            </button><br />
          <button className="loginButton"
            onClick={() => this.props.toggleLogin()}
          >
            戻る
            </button>
        </center>
        </form>
      </div>
    )
  }

  success = () => {
    return (
      <div>
        <center>
          <h2>パスワード変更済み</h2>
          <img src={check} className="check" alt="check" />
          <button onClick={() => this.props.toggleLogin()} className="loginButton">
            ログインに進む
          </button>
        </center>
      </div>
    )
  }

  render() {
    if (this.props.isAuthenticated) {
      return <Redirect to={MAIN} />;
    }

    return (
      <div className="changePasswordCard">
        {this.state.success ? this.success() : this.form()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
  }
};

const mapDispatchToProps = {
  loginUser: authOperations.loginUser,
  logout: authOperations.logoutUser,
  changePassword: authOperations.changePassword,
  validate: authSelectors.validate
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangePassword));